import { useEffect } from "react";
import { useHistory } from "react-router-dom";
import { Routes } from "constants/routes";
import { usePrimarySubscription } from "hooks/Subscriptions/usePrimarySubscription";

export const useCheckUserSubscriptionOnMount = () => {
  const history = useHistory();
  const { primarySubscription } = usePrimarySubscription();

  useEffect(function checkUserSubscriptionOnMount() {
    if (primarySubscription?.isActive) {
      history.push(Routes.account__subscription);
    }
  }, []);
};
